module.exports = __webpack_public_path__ + "img/bw_wings1.6994a791.jpg";